module.exports = __webpack_public_path__ + "static/media/5.1ab11a11.png";